import { render, staticRenderFns } from "./modal-error.vue?vue&type=template&id=591435cf&scoped=true"
import script from "./modal-error.vue?vue&type=script&lang=js"
export * from "./modal-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591435cf",
  null
  
)

export default component.exports